export enum FinanceTypes {
  FINANCE = 'lease finance option',
  CASH = 'cash finance option',
}

export enum AffiliationTypes {
  STOCK_NVL = 'sl-nvl',
  STOCK_AVL = 'sl-avl',
  NON_STOCK = 'sl-nvl-config',
}

export enum EventDataTypes {
  DOWN_ARROW = 'down arrow',
  UP_ARROW = 'up arrow',
  BUTTON = 'button',
  BUTTON_NAME = 'change',
  EOI_ADD_BUTTON_TEXT = 'add',
  EOI_REMOVE_BUTTON_TEXT = 'remove',
  NEXT_BUTTON = 'next',
  CHECKOUT = 'checkout',
  CHECKOUT_CLICK = 'checkout click',
  BACK_TO_FINANCIAL_CALCULATOR = 'back to financial calculator',
  SELECT_DEALER = 'select',
  BACK_TO_HOME_PAGE = 'back to home page',
  SUBMIT = 'submit',
  URL_CTA = 'url link',
  BACK_CTA = 'back',
  CHECKBOX = 'checkbox',
  TRADEIN_CTA = 'add a car for your settlement',
  SKIP_CAR = 'skip car',
  DROPDOWN = 'dropdown',
  TRADEIN_BRAND = 'make',
  TEXT_INPUT = 'text input',
  TRADEIN_MODEL = 'model',
  TRADEIN_MILEAGE = 'mileage',
  TRADEIN_YEAR = 'year of manufacture',
  TRADEIN_REGISTRATION_NUMBER = 'registration number',
  ANCHOR_TEXT = 'anchor text',
  SEND_ENQUIRY = 'send enquiry',
}
